import moment from "moment";

export function getTodayDate(returnType) {
    const todayDate = new Date();
    let year = todayDate.getFullYear();
    let month = 1 + todayDate.getMonth();
    month = month >= 10 ? month : "0" + month;
    let day = todayDate.getDate();
    day = day >= 10 ? day : "0" + day;
    const date = getDateDay(todayDate);
    if (returnType === "YMDD") return year + "년" + month + "월 " + day + "일 " + date;
    if (returnType === "YYYYMMDD") return year + "." + month + "." + day + "";
    else if (returnType === "MDD") return month + "월 " + day + "일 " + date;
    else if (returnType === "MD") return month + "월 " + day + "일";
    else return year + "" + month + "" + day;
}

export function getFormatDate() {
    var date = new Date();
    var year = date.getFullYear();
    var month = 1 + date.getMonth();
    month = month >= 10 ? month : "0" + month;
    var day = date.getDate();
    day = day >= 10 ? day : "0" + day;
    return year + "" + month + "" + day;
}

export function getMMDDDay() {
    const today = new Date();
    const month = today.getMonth() + 1;
    const date = today.getDate();
    const day = getDateDay(today);
    return `${month}월 ${date}일 ${day}요일`;
}

export function gethhmmss() {
    const today = new Date();

    let h = today.getHours();
    let m = today.getMinutes();
    let s = today.getSeconds();

    if (m < 10) {
        m = "0" + m;
    }

    if (s < 10) {
        s = "0" + s;
    }

    return h + "" + m + "" + s;
}

export function getParseHHMM(param) {
    let result = "";
    try {
        const hh = parseInt(param.substring(0, 2));
        const mm = param.substring(2, 4);

        if (parseInt(hh) > 12) {
            result += "오후 ";
            result += hh - 12;
        } else {
            result += "오전";
            result += hh;
        }
        result += "시 ";
        result += mm;
        result += "분";
    } catch (error) {
        console.log(error);
    }
    return result;
}

export function getCurrentDate() {
    let date = new Date(); // Data 객체 생성
    let year = date.getFullYear().toString(); // 년도 구하기

    let month = date.getMonth() + 1; // 월 구하기
    month = month < 10 ? "0" + month.toString() : month.toString(); // 10월 미만 0 추가

    let day = date.getDate(); // 날짜 구하기
    day = day < 10 ? "0" + day.toString() : day.toString(); // 10일 미만 0 추가

    let hour = date.getHours(); // 시간 구하기
    hour = hour < 10 ? "0" + hour.toString() : hour.toString(); // 10시 미만 0 추가

    let minites = date.getMinutes(); // 분 구하기
    minites = minites < 10 ? "0" + minites.toString() : minites.toString(); // 10분 미만 0 추가

    let seconds = date.getSeconds(); // 초 구하기
    seconds = seconds < 10 ? "0" + seconds.toString() : seconds.toString(); // 10초 미만 0 추가

    return year + month + day + hour + minites + seconds; // yyyymmddhhmmss 형식으로 리턴
}

export function getDateDay(date) {
    const week = new Array("일", "월", "화", "수", "목", "금", "토");

    const today = date.getDay();
    const todayDay = week[today];

    return todayDay;
}

export const getDayFromStringDate = (dateString) => {
    const daysOfWeek = ["일", "월", "화", "수", "목", "금", "토"];
    const date = new Date(dateString.replace(/\./g, "-"));
    return daysOfWeek[date.getDay()];
};

export function getStartWeek() {
    return new Date().getWeek();
}

export function getTodayDateOfYYYYMMDD() {
    return moment();
}

// 주차 구하기
Date.prototype.getWeek = function getWeek() {
    var newYear = new Date(this.getFullYear(), 0, 1);
    var day = newYear.getDay();
    day = day >= 0 ? day : day + 7;
    var daynum =
        Math.floor(
            (this.getTime() - newYear.getTime() - (this.getTimezoneOffset() - newYear.getTimezoneOffset()) * 60000) /
                86400000,
        ) + 1;
    var weeknum;

    if (day < 4) {
        weeknum = Math.floor((daynum + day - 1) / 7) + 1;
        if (weeknum > 52) {
            let nYear = new Date(this.getFullYear() + 1, 0, 1);
            let nday = nYear.getDay();
            nday = nday >= 0 ? nday : nday + 7;
            weeknum = nday < 4 ? 1 : 53;
        }
    } else {
        weeknum = Math.floor((daynum + day - 1) / 7);
    }
    return weeknum;
};

export function diffSecondsNow(dateParam) {
    return moment(new Date()).diff(dateParam, "seconds");
}

export function diffSecondsCompareDate(fromDateParam, toDateParam) {
    return moment(fromDateParam).diff(toDateParam, "seconds");
}
